import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../AuthProvider/AuthProvider'

const ProtectedBoostXpressAdmin = () => {
  const { isLocalAuth } = useAuth()

  switch (isLocalAuth) {
    case false:
      return <Navigate to='/login' replace />
    case true:
      return <Outlet />
    default:
      return <Navigate to='/login' replace />
  }
}

export default ProtectedBoostXpressAdmin
